import { Component, OnInit, ViewChild, ElementRef, TemplateRef } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MatToolbarModule } from '@angular/material/toolbar'
import { AutocompleteMapComponent } from '../autocomplete-map/autocomplete-map.component'
// import { GoogleMapsModule } from '@angular/google-maps'
import { MapAppComponent } from 'src/app/components/map-app/map-app.component'
import { AdresssService } from './adresss.service'
import {
  GoogleMap,
  GoogleMapsModule,
  MapCircle,
  MapDirectionsService,
  MapInfoWindow,
  MapMarker,
} from '@angular/google-maps'
import { Router } from '@angular/router'
import {
  MatDialog,
  MatDialogConfig,
} from '@angular/material/dialog'
import { MaterialModule } from 'src/app/shared/material'
import { FormmarkerComponent } from './formmarker/formmarker.component'
import { map } from 'rxjs/operators';
import { pipe } from 'rxjs';

@Component({
  selector: 'app-places',
  standalone: true,
  providers: [AdresssService],
  imports: [
    CommonModule,
    MatToolbarModule,
    AutocompleteMapComponent,
    MapAppComponent,
    GoogleMapsModule,
    MaterialModule,
  ],
  template: `
    <!-- <mat-toolbar color="primary">
      Search Journey
    </mat-toolbar> -->
    <div class="container">
      <app-autocomplete-map placeholder="Enter location"></app-autocomplete-map>
      <google-map
        height="500px"
        width="100%"
        [zoom]="zoom"
        [center]="center"
        [options]="options"
        (mapClick)="click($event)"
      >
        <map-marker
          #markerElem
          *ngFor="let item of dataMap"
          [position]="item.position ? item.position : position"
          [icon]="'../../../assets/maps/blackicon.png'"
          width="20"
          height="20"
          [title]="item.address"
          [options]="item.address"
          (mapClick)="viewDataLatLong(item.id)"
        ></map-marker>

        <map-marker
          #markerElem
          *ngFor="let item of markers"
          [position]="item.position ? item.position : position"
          [icon]="'../../../assets/maps/icons8-lighthouse-24.png'"
          width="20"
          height="20"
          [title]="item.address"
          [options]="item.address"
          (mapClick)="viewDataLatLongGenerate(item.id)"
        ></map-marker>

        <map-info-window>{{ markers }}</map-info-window>
      </google-map>
      <div class="mt-4 grid grid-cols-2">
        <button class="btn btn-outline-primary" (click)="zoomIn()">
          Zoom in
        </button>
        <button class="btn btn-outline-primary" (click)="zoomOut()">
          Zoom out
        </button>
      </div>
      <div class="mt-5">
        <p>
          <img src="{{streetViewImage}}" alt="">
        </p>
      </div>
    </div>
  `,
  styles: [],
})
export class PlacesComponent implements OnInit {
  @ViewChild(MapInfoWindow, { static: true }) infoWindows!: MapInfoWindow
  @ViewChild('markerElem') markerElem!: ElementRef

  public position = {
    lat: 41.8719,
    lng: 12.5674,
  }
  zoom = 7;
  center: any
  options: any = {
    mapTypeId: 'hybrid',
    zoomControl: false,
    scrollwheel: false,
    disableDoubleClickZoom: true,
    maxZoom: 15,
    minZoom: 8,
  }
  markers: any[] = []
  infonContent: any
  adress: any[] = []
  fakeId: any
  check!: string
  dataMap: any
  mapDatabase: any[] = []
  markersData: any[] = []
  streetViewImage!: string | ArrayBuffer | null

  constructor(
    private adressService: AdresssService,
    public dialog: MatDialog,
    private router: Router
  ) {}

  ngOnInit(): void {
    navigator.geolocation.getCurrentPosition((position: any) => {
      this.center = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      }
    })
    this.getPlaces()
    console.log(this.markersData)
    let url = window.location.href;
    console.log(url)
  }

  getPlaces(){
    this.adressService.getMapService().pipe(map((items: any) => {
      this.check = 'lama'
      const postArray = [];
      for(const key in items){
        if(items.hasOwnProperty(key)){
          postArray.push({...items[key], id: key})
        }
      }
      return postArray;
    })).subscribe((value: any) => {
      console.log(value);
      this.dataMap = value;
      this.markersData.push({
        position: {
          lat: value.lat,
          lng: value.lng,
        },
        label: {
          color: 'white',
          text:
            value.lat +
            ',' +
            value.lng
        },
        title: {
          titile: 'marker title',
          options: { animation: google.maps.Animation.BOUNCE },
        },
        address: this.adress,
        id: this.fakeId,
      })
    })
  }

  zoomIn() {
    if (this.zoom < this.options.maxZoom) this.zoom++
  }

  zoomOut() {
    if (this.zoom > this.options.minZoom) this.zoom--
  }

  click(event: google.maps.MapMouseEvent) {
    this.fakeId = Math.floor(Math.random() * 100000000)
    console.log(event.latLng?.lat())
    console.log(event.latLng?.lng())

    this.adressService
      .getGeolocation(event.latLng?.lat(), event.latLng?.lng())
      .subscribe((value: any) => {
        console.log(value, 'ini alamat')
        this.adress = value.results[2].formatted_address
        // this.markers.push(value.results[2].formatted_address)
        // this.adress.map((item: any) => )
        this.markers.push({
          position: {
            lat: event.latLng?.lat(),
            lng: event.latLng?.lng(),
          },
          label: {
            color: 'white',
            text:
              event.latLng?.lat() +
              ',' +
              event.latLng?.lng() +
              ',' +
              event.domEvent.bubbles,
          },
          title: {
            titile: 'marker title',
            options: { animation: google.maps.Animation.BOUNCE },
          },
          address: this.adress,
          id: this.fakeId,
        })
      })
    console.log(this.markers, 'parent')

    this.adressService.getStreetViewImage(event.latLng!.lat(), event.latLng!.lng(), 180, 10, 400, 400, 'AIzaSyDFaXNvUSNlqQoqlNBgCgppWcSeYxb5kDM')
    .subscribe(streetViewImage => {
      const reader = new FileReader();
      reader.addEventListener('load', () => {
        this.streetViewImage = reader.result;
      }, false);
      reader.readAsDataURL(streetViewImage);
      console.log(JSON.stringify(streetViewImage));
    });
  }

  viewDataLatLongGenerate(id: any) {
    const dialogConfig = new MatDialogConfig()
    dialogConfig.disableClose = true
    dialogConfig.width = '1000px'
    const data = this.markers.filter((item: any) => {
      return item.id == id
    })
    console.log(data, 'generate')

    dialogConfig.data = {
      titleDialog: 'Tambah lokasi aset',
      dataDialog:data,
    }
    const dialogRef = this.dialog.open(FormmarkerComponent, dialogConfig)
    dialogRef.afterClosed().subscribe((result: any) => {
      console.log(result)
      this.getPlaces()
    })
  }

  viewDataLatLong(id: any) {
    const dialogConfig = new MatDialogConfig()
    dialogConfig.disableClose = true
    dialogConfig.width = '1000px'
    const database = this.dataMap.filter((item: any) => {
      return item.id == id
    })
    dialogConfig.data = {
      titleDialog: 'Tambah lokasi aset',
      dataDialog: database,
    }
    const dialogRef = this.dialog.open(FormmarkerComponent, dialogConfig)
    dialogRef.afterClosed().subscribe((result: any) => {
      console.log(result)
      this.getPlaces()
    })
  }


  openInfo(content: any) {
    this.infonContent = content
    this.infoWindows.open(content)
  }

  getData(){
    this.adressService.getStreetViewImage(12312, -122.4365, 180, 10, 400, 400, 'YOUR_API_KEY')
    .subscribe(streetViewImage => {
      const reader = new FileReader();
      reader.addEventListener('load', () => {
        this.streetViewImage = reader.result;
      }, false);
      reader.readAsDataURL(streetViewImage);
    });
  }
  }
